import { makeAutoObservable, runInAction } from 'mobx';
import { showToast } from '../../../utils/toast';
import { GHG_REPORTING_INITIAL } from '../constants/onboard.constant';
import { ghgReportingURL } from '../api/url';
import { handleFetch } from '../../../utils/handleFetch';

class GHGReportingStore {
	GHGReportingForm = GHG_REPORTING_INITIAL;
	isGHGReportingChanged = false;

	constructor() {
		makeAutoObservable(this);
	}

	getGHGReporting = async () => {
		return await handleFetch({
			url: ghgReportingURL,
			method: 'GET',
			onSuccess: (data) => runInAction(() => (this.GHGReportingForm = data)),
		});
	};

	updateGHGReporting = async ({ silent = false } = {}) => {
		if (silent) {
			const success = await handleFetch({
				url: ghgReportingURL,
				method: 'PUT',
				body: this.GHGReportingForm,
				onSuccess: (data) => {
					runInAction(() => {
						this.GHGReportingForm = data;
						this.isGHGReportingChanged = false;
					});
				},
			});
			if (!success) {
				showToast.error('Failed to update GHG reporting');
			}
			return success;
		}

		return showToast.promise(
			(async () => {
				const success = await handleFetch({
					url: ghgReportingURL,
					method: 'PUT',
					body: this.GHGReportingForm,
					onSuccess: (data) => {
						runInAction(() => {
							this.GHGReportingForm = data;
							this.isGHGReportingChanged = false;
						});
					},
				});
				if (!success) throw new Error('Failed to update GHG reporting');
				return success;
			})(),
			{
				loading: 'Updating GHG reporting...',
				success: 'GHG reporting updated successfully!',
				error: 'Failed to update GHG reporting',
			},
		);
	};

	handleChangeGHGReporting = (e) => {
		const { id, value } = e.target;
		this.GHGReportingForm[id] = value;
		this.isGHGReportingChanged = true;
	};
}

export const ghgReportingStore = new GHGReportingStore();
